// @flow
import { combineReducers } from 'redux'
import earningsReducer from './earnings'
import targetsReducer from './targets'
import userReducer from './user'
import stockReducer from './stock'
import portfoliosReducer from './portfolios'
import riskReducer from './risk'
import gridReducer from './grid'
import postsReducer from './posts'
import ordersReducer from './orders'
import categoriesReducer from './categories'
import calendersReducer from './calenders'
import accountsReducer from './account'

// Root reducer
export const allReducers = combineReducers({
  earnings: earningsReducer,
  targets: targetsReducer,
  user: userReducer,
  stock: stockReducer,
  portfolios: portfoliosReducer,
  risk: riskReducer,
  grid: gridReducer,
  posts: postsReducer,
  orders: ordersReducer,
  categories: categoriesReducer,
  calenders: calendersReducer,
  account: accountsReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/index.js